import FlagIcon from "@mui/icons-material/Flag";
import OutlinedFlagIcon from "@mui/icons-material/OutlinedFlag";
import ReportIcon from "@mui/icons-material/Report";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

import { TASK_PRIORITIES, TASK_PRIORITY_COLORS } from "constants/staff-tasks";

import type { PriorityLabelProps } from "./priority-label-props.type";

export default function PriorityLabel({
  priority = 0,
  isRow = true,
  count,
  sx
}: PriorityLabelProps) {
  const iconColor = TASK_PRIORITY_COLORS.getFromCode(priority);
  const option = TASK_PRIORITIES.getFromCode(priority);
  return (
    <Stack
      direction={isRow ? "row" : "column"}
      columnGap={1}
      alignItems="center"
      sx={{ opacity: count === 0 ? 0.75 : 1 }}
    >
      <Box>
        {!priority ? (
          <OutlinedFlagIcon sx={{ fill: iconColor }} />
        ) : priority === 1 ? (
          <ReportIcon sx={{ fill: iconColor }} />
        ) : (
          <FlagIcon sx={{ fill: iconColor }} />
        )}
      </Box>
      <Typography fontSize="16px" lineHeight="18px" mb={1} sx={sx}>
        {option}
        {Boolean(count) ? ` (${count})` : ""}
      </Typography>
    </Stack>
  );
}
